import React from "react";
import HighLevelDetailedGigPage from "./HighLevelDetailedGigPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface HighLevelDetailedGigPageContainerProps extends RouteProps, withValidUserRoleProps {}

const HighLevelDetailedGigPageContainer = (props: HighLevelDetailedGigPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <HighLevelDetailedGigPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(HighLevelDetailedGigPageContainer);
